<template>
  <section class="lk-step">
    <h2 class="lk-q">Wonach suchst du gerade?</h2>
    <p class="lk-sub">
      Wähl, was zu dir passt — gern auch mehreres. Menschen ändern sich, das ist okay.
    </p>
    <div class="lk-chips">
      <button
        v-for="preference in preferenceOptions"
        :key="preference.id"
        type="button"
        class="lk-chip"
        :class="{ selected: preferences.includes(preference.id) }"
        :aria-pressed="preferences.includes(preference.id)"
        @click="togglePreference(preference.id)"
      >
        <span
          class="ic"
          aria-hidden="true"
        ><component
          :is="preference.icon"
          :size="22"
        /></span>
        <span class="lbl">{{ trans.get('landing:signup.' + preference.labelKey) }}</span>
        <span class="check-mark"><icon-check :size="11" /></span>
      </button>
    </div>
  </section>
</template>

<script>
import { INTENTS } from '../../signup/signupConfig';
import IconCheck from '../../icons/IconCheck.vue';

export default {
  name: 'LeadFunnelStepPreferences',
  components: { IconCheck },
  props: {
    preferences: { type: Array, default: () => [] },
  },
  data() {
    return {
      preferenceOptions: INTENTS,
    };
  },
  methods: {
    // Same rules as IntentStep / PreferencesChooseMixin: picking "no_answer"
    // clears the rest; picking anything else clears "no_answer".
    togglePreference(value) {
      if (this.preferences.includes(value)) {
        this.$emit(
          'update:preferences',
          this.preferences.filter((v) => v !== value),
        );
        return;
      }
      const noAnswerId = INTENTS.find((intent) => intent.value === 'no_answer').id;
      const next =
        value === noAnswerId
          ? [noAnswerId]
          : [...this.preferences.filter((v) => v !== noAnswerId), value];
      this.$emit('update:preferences', next);
    },
  },
};
</script>
